import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Table, Modal, Button, ProgressBar, Form, Dropdown } from 'react-bootstrap';
import { FaPlus, FaCheck, FaEdit, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUniversalAccess, FaTools, FaEllipsisV, FaChartLine, FaRedo, FaCogs, FaFileImport, FaAngleDoubleUp, FaArrowRight, FaArrowLeft, FaFileExcel, FaFilePdf } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import useAuth from '../../dashboard/useAuth';
import axios from 'axios';

const Liste_parcours = ({ titre }) => {
    useAuth();
    const [parcours, setParcours] = useState([]);
    const [selectedParcours, setSelectedParcours] = useState(null);
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [showModifModal, setShowModifModal] = useState(false);
    const [showImportModal, setShowImportModal] = useState(false);
    const [isGlobaleLoading, setIsGlobaleLoading] = useState(false); // Pour gérer le loader
    const [isDupliquerLoading, setIsDupliquerLoading] = useState(false); // Pour gérer le loader
    const [nouvParcours, setNouvParcours] = useState({
        titre: '',
        nbre_heure: '',
    });
    const [modifParcours, setModifParcours] = useState({
        titre: '',
        nbre_heure: '',
    });
    const [showReinitialiserModal, setShowReinitialiserModal] = useState(false);
    const [showSupprimerModal, setShowSupprimerModal] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [alertModal, setAlertModal] = useState({ message: '', type: '' });

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const totalItems = parcours.length;  // Si 'formationList' contient toutes les formations


    const location = useLocation();

    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Parcours d'apprentissage";
        }
    }, [user_id]);


    const fetchParcours = async () => {
        setIsGlobaleLoading(true)
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-parcours/');
            const data = await response.json();
            if (response.ok) {
                setParcours(data.parcours);
            } else {
                console.error('Erreur lors de la récupération des parcours : ', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsGlobaleLoading(false)
        }
    };
    useEffect(() => {
        fetchParcours();
    }, []);

    // Handle alerts
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        fetchParcours()
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 3000);
    };

    // Handle alerts
    const showAlertModal = (message, type = 'success') => {
        setAlertModal({ message, type });
        fetchParcours()
        setTimeout(() => {
            setAlertModal({ message: '', type: '' });
        }, 10000);
    };

    const handleRowClick = (parcours) => {
        setSelectedParcours(parcours);
    };


    // Filter formations by search term
    const filteredParcours = parcours.filter(parcours =>
        parcours.titre.toLowerCase().includes(searchTerm.toLowerCase()) ||
        parcours.nbre_heure.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (parcours.nbre_semaine && parcours.nbre_semaine.toString().includes(searchTerm.toLowerCase()))
    );

    // Sort Parcourss
    const sortedParcours = [...filteredParcours].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Pagination logic
    const indexOfLastParcours = currentPage * itemsPerPage;
    const indexOfFirstParcours = indexOfLastParcours - itemsPerPage;
    const currentParcours = sortedParcours.slice(indexOfFirstParcours, indexOfLastParcours);
    const totalPages = Math.ceil(sortedParcours.length / itemsPerPage);

    // Handle items per page change
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // Handle modifier action
    const handleConfiguration = async (parcours) => {
        // if (!parcours) return;

        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/synchroniser-etapes-utilisateurs/${selectedParcours.id}/`
            );
        } catch (error) {
            console.error("Erreur de synchronisation :", error);
        }

        navigate(`/Configuration-parcours`, {
            state: { parcours_id: selectedParcours.id, parcours_titre: selectedParcours.titre },
        });
    };


    // Handle show delete modal
    const handleShowReinitialiserModal = () => setShowReinitialiserModal(true);
    const handleFermerReinitialiserModal = () => setShowReinitialiserModal(false);

    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => setShowAddModal(false);

    const handleShowModifModal = () => setShowModifModal(true);
    const handleCloseModifModal = () => setShowModifModal(false);

    const handleShowSupprimerModal = () => setShowSupprimerModal(true);
    const handleCloseSupprimerModal = () => setShowSupprimerModal(false);

    const handleShowImportModal = () => {
        setShowImportModal(true);
    };
    const handleCloseImportModal = () => {
        setShowImportModal(false);
    };
    const [progress, setProgress] = useState(0);
    const [isImporting, setIsImporting] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]); // Met à jour l'état du fichier sélectionné
    };


    const handleEnregParcours = async () => {
        // Vérification des champs vides
        if (!nouvParcours.titre.trim()) {
            showAlertModal('Le titre est obligatoire. Veuillez le renseigner.', 'danger');
            return;
        }

        if (!nouvParcours.nbre_heure.trim()) {
            showAlertModal("Veuillez renseigner le nombre d'heures en chiffre uniquement.", 'danger');
            return;
        }

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/ajouter-parcours/${user_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(nouvParcours),
            });

            if (response.ok) {
                const result = await response.json();
                showAlert('Parcours ajouté avec succès !');
                handleCloseAddModal();
                setNouvParcours({
                    titre: '',
                    nbre_heure: '',
                });
            } else {
                const errorData = await response.json();
                console.error('Erreur du serveur:', errorData);
                showAlert('Erreur lors de l’ajout du parcours : ' + (errorData.message || 'Erreur inconnue.'));
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur. Veuillez réessayer plus tard.');
        }
    };



    const handleDupliquerParcours = async () => {
        if (selectedParcours) {
            setIsDupliquerLoading(true)
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/dupliquer-parcours/${selectedParcours.id}/${user_id}/`, {
                    method: 'POST',
                });

                if (response.ok) {
                    setSelectedParcours(null);
                    showAlert(`parcours ${selectedParcours.titre} dupliqué avec succès !`);
                } else {
                    const data = await response.json();
                    console.error('Erreur lors de la duplication du parcours', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsDupliquerLoading(false);
            }
        }
    };


    const handleSupprimerParcours = async () => {
        if (selectedParcours) {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/supprimer-parcours/${selectedParcours.id}/${user_id}/`, {
                    method: 'DELETE',
                });

                const data = await response.json();
                if (response.ok) {
                    setSelectedParcours(null);
                    showAlert("parcours supprimé avec succès !");
                } else {
                    console.error('Erreur lors de la suppression de la parcours', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setShowSupprimerModal(false);
            }
        }
    };


    const fetchInfoData = async () => {
        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/parcours-info/${selectedParcours.id}/`);
            if (!response.ok) throw new Error('Erreur réseau');
            const data = await response.json();
            setModifParcours(data);
        } catch (error) {
            console.error('Erreur lors de la récupération des données du parcours:', error);
        }
    };


    const handleExporterParcours = async (format = 'xlsx') => {
        if (!selectedParcours) {
            showAlert('Veuillez sélectionner un parcours d\'abord', 'danger');
            return;
        }

        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/exporter-etapes-parcours/${selectedParcours.id}/${user_id}/`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ format: format }),
                }
            );

            if (response.ok) {
                // Récupérer le blob du fichier
                const blob = await response.blob();

                // Créer une URL pour le blob
                const url = window.URL.createObjectURL(blob);

                // Créer un lien de téléchargement
                const a = document.createElement('a');
                a.href = url;

                // Déterminer le nom du fichier à partir des headers ou utiliser un nom par défaut
                const contentDisposition = response.headers.get('Content-Disposition');
                let filename = `parcours_${selectedParcours.titre}_etapes.${format}`;

                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1];
                    }
                }

                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // Libérer l'URL
                window.URL.revokeObjectURL(url);

                showAlert(`Export ${format.toUpperCase()} généré avec succès !`);
            } else {
                const errorData = await response.json();
                showAlert(`Erreur lors de l'export: ${errorData.error || 'Erreur inconnue'}`, 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur de connexion au serveur', 'danger');
        }
    };

    useEffect(() => {
        if (selectedParcours?.id != null) {
            fetchInfoData();
        }
    }, [selectedParcours]);


    const handleModifierParcours = async () => {
        // Vérification des champs vides
        if (!modifParcours.titre.trim()) {
            showAlertModal('Le titre est obligatoire. Veuillez le renseigner.', 'danger');
            return;
        }

        if (!modifParcours.nbre_heure.trim()) {
            showAlertModal("Veuillez renseigner le nombre d'heures en chiffre uniquement.", 'danger');
            return;
        }

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-parcours/${selectedParcours.id}/${user_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(modifParcours),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                showAlert('Modification éffectuée avec succès');
                fetchParcours();
                handleCloseModifModal()
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handlefichier = async (event) => {

        const ressource = event.target.files[0]; // Récupérer le fichier sélectionné
        console.log("Fichier sélectionné:", ressource);

        // Validation du type et de la taille du fichier

        const maxFileSize = 50 * 1024 * 1024; // 50 MB



        if (ressource.size > maxFileSize) {
            showAlert("Le fichier est trop volumineux. La taille maximale autorisée est de 50 Mo.");
            return;
        }

        try {
            // Affichage d'un message pendant l'importation
            showAlert("Importation en cours...");

            // Préparer les données à envoyer
            const formData = new FormData();
            formData.append("ressource", ressource);

            // Effectuer la requête POST pour importer le fichier
            const response = await fetch(`${process.env.REACT_APP_HOTE}/importer-ressource/${selectedParcours.id}/${user_id}/`, {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                showAlert("Ressource importé avec succès !");

                fetchParcours(); // Rafraîchir les données de l'étape si nécessaire
            } else {
                const errorData = await response.json();
                console.error("Erreur lors de l'importation:", errorData);
                showAlert("Échec de l'importation. Vérifiez le fichier ou réessayez.");
            }
        } catch (error) {
            console.error("Erreur réseau:", error);
            showAlert("Erreur réseau. Veuillez réessayer.");
        }
        setShowImportModal(false);
    };

    const handleDownload = () => {
        // Construire l'URL pour le téléchargement
        const downloadUrl = `${process.env.REACT_APP_HOTE}/telecharger-ressource/${selectedParcours.id}/${user_id}/`;
        //window.location.href = downloadUrl;

        // Utiliser `fetch` pour vérifier si l'URL est valide
        fetch(downloadUrl, {
            method: "GET",
        })
            .then((response) => {
                if (response.ok) {
                    // Si le fichier existe, redirige l'utilisateur pour lancer le téléchargement
                    window.location.href = downloadUrl;
                } else {
                    showAlert("Le fichier est introuvable ou le téléchargement a échoué.");
                }
            })
            .catch((error) => {
                console.error("Erreur lors du téléchargement :", error);
                showAlert("Une erreur s'est produite lors du téléchargement.");
            });
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Parcours")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }



    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaChartLine size={25} className='mr-2' />Gestion des parcours</h2>
                            <small>Administration des parcours.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-parcours`}> Parcours</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div className="wrapper wrapper-content animated fadeInRight">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des parcours</h5>
                                <div className=''>

                                    {/* <Link className="btn btn-success d-flex align-items-center justify-content-center ms-2 mr-2 mt-1" to={`/Cohorte`}> Cohorte</Link> */}

                                    <Link onClick={handleShowAddModal} className="btn btn-success d-flex align-items-center justify-content-center ms-2 mt-1">
                                        <FaPlus />
                                        <span className="d-none d-sm-inline ml-2">
                                            Ajouter
                                        </span>
                                    </Link>
                                    {/* <button
                                        onClick={handleShowModifModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedParcours ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedParcours}
                                    >
                                        <FaEdit />
                                        <span className="d-none d-sm-inline ml-2">
                                            Modifier
                                        </span>
                                    </button>
                                    <button
                                        onClick={() => handleConfiguration(selectedParcours)}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedParcours ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedParcours}
                                    >
                                        <FaCogs />
                                        <span className="d-none d-sm-inline ml-2">
                                            Configuration
                                        </span>
                                    </button>
                                    <button
                                        onClick={handleShowImportModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedParcours ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedParcours}
                                    >
                                        <FaFileImport />
                                        <span className="d-none d-sm-inline ml-2">
                                            Importer Ressources
                                        </span>
                                    </button>
                                    {isDupliquerLoading ? (
                                        <button className="btn btn-success mr-2" disabled>
                                            <i className="fa fa-spinner fa-spin mr-1"></i>
                                            <span className="d-none d-sm-inline ml-2">
                                                Chargement...
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            onClick={handleDupliquerParcours}
                                            className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedParcours ? 'btn-success' : 'btn-default text-dark'}`}
                                            disabled={!selectedParcours}
                                        >
                                            <FaAngleDoubleUp />
                                            <span className="d-none d-sm-inline ml-2">
                                                Dupliquer
                                            </span>
                                        </button>
                                    )}
                                    <button
                                        onClick={handleShowSupprimerModal}
                                        className={`btn d-flex align-items-center justify-content-center ms-2 mr-2 mt-1 ${selectedParcours ? 'btn-success' : 'btn-default text-dark'}`}
                                        disabled={!selectedParcours}
                                    >
                                        <FaTrash />
                                        <span className="d-none d-sm-inline ml-2">
                                            Supprimer
                                        </span>
                                    </button> */}
                                </div>
                            </div>

                            {alert.message && (
                                <div className={`alert alert-${alert.type}`}>
                                    {alert.message}
                                </div>
                            )}

                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">

                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div className="me-2">
                                                    <select
                                                        value={itemsPerPage}
                                                        onChange={handleItemsPerPageChange}
                                                        className="form-select bg-default p-1"
                                                        style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={20}>20</option>
                                                        <option value={50}>50</option>
                                                    </select>
                                                </div>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control"
                                                    style={{ maxWidth: '150px', width: '100%' }} // Largeur fixe ou maximale selon besoin
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-" style={{ fontSize: '11px' }}>
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '150px' }} onClick={() => handleSort('titre')}>
                                                                Titre {sortConfig.key === 'titre'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' style={{ minWidth: '100px' }} onClick={() => handleSort('nbre_heure')}>
                                                                Nbre d'heure {sortConfig.key === 'nbre_heure'}{(sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />)}
                                                            </th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell'>Actions</th>
                                                        </tr>
                                                    </thead>

                                                    {!isGlobaleLoading ? (
                                                        <tbody>
                                                            {currentParcours.length > 0 ? currentParcours.map((parcours) => (
                                                                <tr
                                                                    key={parcours.id}
                                                                    className={`bg-white ${selectedParcours && selectedParcours.id === parcours.id ? 'bg-success text-white' : ''}`}
                                                                    onClick={() => handleRowClick(parcours)}
                                                                >
                                                                    <td>
                                                                        {parcours.titre}
                                                                        {parcours.ressource && (
                                                                            <span
                                                                                onClick={() => handleDownload(parcours.id)}
                                                                                style={{ cursor: "pointer", marginLeft: "8px", color: "blue" }}
                                                                            >
                                                                                <i className="fa fa-download" title="Voir le fichier"></i>
                                                                            </span>
                                                                        )}
                                                                        <div className='lesInfos'>
                                                                            <small>Titre : <small dangerouslySetInnerHTML={{ __html: parcours.titre }}></small></small><br />
                                                                            <small>Nbre d'heure : {parcours.nbre_heure}</small><br />
                                                                        </div>
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {parcours.nbre_heure} heures
                                                                    </td>
                                                                    <td>
                                                                        <Dropdown>
                                                                            <Dropdown.Toggle
                                                                                variant="outline-"
                                                                                size="sm"
                                                                                id={`dropdown-parcours-${parcours.id}`}
                                                                            >
                                                                                <FaEllipsisV />
                                                                            </Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                <Dropdown.Item onClick={() => {
                                                                                    setSelectedParcours(parcours);
                                                                                    handleShowModifModal();
                                                                                }}>
                                                                                    <FaEdit className="mr-2" /> Modifier
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item onClick={() => {
                                                                                    setSelectedParcours(parcours);
                                                                                    handleConfiguration(parcours);
                                                                                }}>
                                                                                    <FaCogs className="mr-2" /> Configuration
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item onClick={() => {
                                                                                    setSelectedParcours(parcours);
                                                                                    handleShowImportModal();
                                                                                }}>
                                                                                    <FaFileImport className="mr-2" /> Importer Ressources
                                                                                </Dropdown.Item>

                                                                                {isDupliquerLoading ? (
                                                                                    <Dropdown.Item disabled>
                                                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                                                        <span className="d-none d-sm-inline ml-2">
                                                                                            Chargement...
                                                                                        </span>
                                                                                    </Dropdown.Item>
                                                                                ) : (
                                                                                    <Dropdown.Item onClick={() => {
                                                                                        setSelectedParcours(parcours);
                                                                                        handleDupliquerParcours();
                                                                                    }}>
                                                                                        <FaAngleDoubleUp className="mr-2" /> Dupliquer
                                                                                    </Dropdown.Item>
                                                                                )}

                                                                                <Dropdown.Item onClick={() => handleExporterParcours('xlsx')}>
                                                                                    <FaFileExcel className="mr-2 text-success" /> Exporter en Excel
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Item onClick={() => handleExporterParcours('pdf')}>
                                                                                    <FaFilePdf className="mr-2 text-danger" /> Exporter en PDF
                                                                                </Dropdown.Item>

                                                                                <Dropdown.Divider />

                                                                                <Dropdown.Item onClick={() => {
                                                                                    setSelectedParcours(parcours);
                                                                                    handleShowSupprimerModal();
                                                                                }} className="text-danger">
                                                                                    <FaTrash className="mr-2" /> Supprimer
                                                                                </Dropdown.Item>
                                                                            </Dropdown.Menu>
                                                                        </Dropdown>
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">Aucun parcours disponible</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="3" className="text-center p-5">
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <div className="spiner-example">
                                                                            <div className="sk-spinner sk-spinner-wave">
                                                                                <div className="sk-rect1 mr-1"></div>
                                                                                <div className="sk-rect2 mr-1"></div>
                                                                                <div className="sk-rect3 mr-1"></div>
                                                                                <div className="sk-rect4 mr-1"></div>
                                                                                <div className="sk-rect5"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${indexOfFirstParcours + 1} à ${Math.min(indexOfLastParcours, totalItems)} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5; // Nombre total de pages à afficher
                                                        let startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
                                                        let endPage = Math.min(totalPages, startPage + pagesToShow - 1);

                                                        // Ajuster le startPage si la fin dépasse le total des pages
                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(1, endPage - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];

                                                        // Ajout des boutons de pages
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i ? 'btn-default' : 'btn-light'} mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(currentPage < totalPages ? currentPage + 1 : totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>

                                                    {/* Bouton pour aller à la dernière page */}
                                                    <button
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        {totalPages}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal de l'importation */}
                    <Modal show={showImportModal} onHide={handleCloseImportModal}>
                        <Modal.Header>
                            <Modal.Title>Importation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <Form.Group controlId="formFile" className="mt-3">
                                <Form.Label>Choisissez un fichier à importer</Form.Label>
                                <Form.Control type="file" onChange={handlefichier} />
                            </Form.Group>
                            {isImporting && (
                                <div className="mt-3">
                                    <ProgressBar now={progress} label={`${Math.round(progress)}%`} />
                                </div>
                            )}
                        </Modal.Body>
                    </Modal>

                    <Modal show={showAddModal} onHide={handleCloseAddModal}>
                        <Modal.Header>
                            <Modal.Title>Ajouter parcours</Modal.Title>
                        </Modal.Header>
                        {alertModal.message && (
                            <div className={`m-3 alert alert-${alertModal.type}`}>
                                {alertModal.message}
                            </div>
                        )}
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={nouvParcours.titre}
                                        onChange={(event) => {
                                            setNouvParcours({
                                                ...nouvParcours,
                                                titre: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre d'heure</Form.Label>
                                    <Form.Control
                                        type="number"
                                        required
                                        value={nouvParcours.nbre_heure}
                                        onChange={(event) => {
                                            setNouvParcours({
                                                ...nouvParcours,
                                                nbre_heure: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>

                                {/* Section des boutons */}
                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseAddModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        className="me-2 mr-2"
                                        onClick={() => handleEnregParcours()}
                                    >
                                        Enregistrer
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showModifModal} onHide={handleCloseModifModal}>
                        <Modal.Header>
                            <Modal.Title>Modifier parcours</Modal.Title>
                        </Modal.Header>
                        {alertModal.message && (
                            <div className={`m-3 alert alert-${alertModal.type}`}>
                                {alertModal.message}
                            </div>
                        )}
                        <Modal.Body>
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label>Titre</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required
                                        value={modifParcours.titre}
                                        onChange={(event) => {
                                            setModifParcours({
                                                ...modifParcours,
                                                titre: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre d'heure</Form.Label>
                                    <Form.Control
                                        type="number"
                                        required
                                        value={modifParcours.nbre_heure}
                                        onChange={(event) => {
                                            setModifParcours({
                                                ...modifParcours,
                                                nbre_heure: event.target.value,
                                            });
                                        }}
                                    />
                                </Form.Group>

                                {/* Section des boutons */}
                                <div className="d-flex justify-content-end mt-4">
                                    <Button
                                        variant="secondary"
                                        className="me-2 mr-2"
                                        onClick={handleCloseModifModal}
                                    >
                                        Annuler
                                    </Button>
                                    <Button
                                        variant="success"
                                        className="me-2 mr-2"
                                        onClick={() => handleModifierParcours()}
                                    >
                                        Modifier
                                    </Button>
                                </div>
                            </Form>
                        </Modal.Body>
                    </Modal>

                    <Modal show={showReinitialiserModal} onHide={handleFermerReinitialiserModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la reinitialisation</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir réinitialiser le parcours : {selectedParcours && selectedParcours.titre} ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleFermerReinitialiserModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleDupliquerParcours}>
                                Reinitialiser
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showSupprimerModal} onHide={handleCloseSupprimerModal}>
                        <Modal.Header>
                            <Modal.Title>Confirmer la suppression</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Êtes-vous sûr de vouloir supprimer le parcours : {selectedParcours && selectedParcours.titre} ?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseSupprimerModal}>
                                Annuler
                            </Button>
                            <Button variant="success" onClick={handleSupprimerParcours}>
                                Supprimer
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Liste_parcours;
